import React from 'react';

const SeedComponent = () => {
    return (
        <div className='container mx-auto p-10'>
            <h1 className='text-center text-[35px] lg:text-[50px] text-[#002060] font-bold leading-[40px] lg:leading-[60px]' data-aos="fade-up">SEED SUSTAINABLE EFFICIENCY AND <br/> EMPLOYEE DEVELOPMENT</h1>
            <div className='mt-[30px] mb-[30px]' data-aos="fade-down">
                <img src="https://i.ibb.co/KXKGFXK/Sevices-SEED.jpg" alt="Mind Works Seed"/>
            </div>
            <p className='lg:text-[22px] text-center' data-aos="fade-up">There are 4 things that are integral to the success of your company: Processes, People, Product, and Purpose. SEED, which is, Sustainable Efficiency and Employee Development is a solution specifically designed to help your company enhance the 3Ps of success. SEED is a solution that is customized to the needs of your company depending on the objectives and goals to be achieved. The core philosophy behind SEED is helping your company achieve efficiency through solutions that are sustainable, driven by employees who are trained and equipped to carry forward productive practices.</p>
        </div>
    );
};

export default SeedComponent;